import React, { useReducer } from 'react'
import axios from 'axios'
import ProjectReducer from './projectReducer'
import ProjectContext from './projectContext'
import { GET_PROJECTS, PROJECT_ERROR, GET_PROJECTS_BY_CATEGORY } from '../types'

const ProjectState = props => {

    const initialState = {
        projects: null,
        categories: null,
        count: 0,
        loading: true
    }

    const [state, dispatch] = useReducer(ProjectReducer, initialState)

    const getAllProjects = async () => {
        try {
            const res = await axios(`${process.env.REACT_APP_PROXY}/api/projects`)
            const projects = res.data.data.reverse();
            const set = new Set(projects.map(pro => pro.category))
            const arr = Array.from(set);
            dispatch({
                type: GET_PROJECTS,
                payload: { projects, categories: arr}
            })
        } catch (err) {
            console.error(err)
            dispatch({ type: PROJECT_ERROR })
        }
    }

    const getProjectsByCategory = async (category) => {
        try {
            const res = await axios(`${process.env.REACT_APP_PROXY}/api/projects/${category}`)
            const projects = res.data.data.reverse();
            dispatch({
                type: GET_PROJECTS_BY_CATEGORY,
                payload: projects
            })
        } catch (err) {
            console.error(err)
            dispatch({ type: PROJECT_ERROR })
        }
    }

    return (
        <ProjectContext.Provider
        value={{
            projects: state.projects,
            loading: state.loading,
            categories: state.categories,
            count: state.count,
            getAllProjects,
            getProjectsByCategory,
        }}
        >
            { props.children }
        </ProjectContext.Provider>
    )
}


export default ProjectState
